//import pages
import Layout from './pages/Layout';
import Home from './pages/Home';
import ProjectDetails from './pages/ProjectDetails';
import NoPage from './pages/NoPage';
import ProjectDirectory from './pages/ProjectDirectory.jsx'
import Services from './pages/Services.jsx'
import Contact from './pages/Contact';
import AnimatedRoutes from './components/AnimatedRoutes.jsx';
import ScrollToTop from './components/ScrollToTop.jsx';

//import hooks
import {  BrowserRouter as Router, Route, Routes, useLocation} from 'react-router-dom';

// data imports
import projectsData from './data/projects.json';

//import components
import Cursor from './components/Cursor.jsx';

function App() {

  console.log(process.env.REACT_APP_PUBLIC_URL);

  return (
    <div>

      <AnimatedRoutes />

      <ScrollToTop />
      
      <Routes basename="/">
        <Route path='/' element= {<Layout />}>
          <Route path='/' element= {<Home />} />
          {projectsData.map((project) => (
            <Route
              key= {project.ID}
              path={`/proyecto/${project.ID}`} 
              element= {<ProjectDetails project={ project } />} 
            />
          ))}
          <Route path='/projects' element= {<ProjectDirectory />} />
          <Route path='/services' element= {<Services />} />
          <Route path='/contacto' element= {<Contact />} />
          <Route path='*' element= {<NoPage />} />
        </Route>
      </Routes>

      <Cursor />
      
    </div>
  );
}

export default App;
